<template>
  <div>
    <div class="box-table">
      <div>
        <button type="button" class="margin-left-sm"
        @click="exportExcel">Exportar datos a Excel</button>
        <v-client-table class="table-virtualaccount"
          :columns="columns"
          :data="filterArray"
          :options="options">
          <div slot="month" slot-scope="{row}">
            {{ row.month }}
          </div>
          <div slot="fr" slot-scope="{row}">
            {{ row.fr }}
          </div>
          <div slot="value" slot-scope="{row}">
            {{ formatCurrency(row.value) }}
          </div>
        </v-client-table>
        <small><b>*</b> La Información en este documento es soportada y detallada en el reporte de Cuenta Virtual, disponible en la plataforma.</small> <br>
        <small><b>*</b> Para el tema fiscal debes considerar que sí tu esquema de facturación es crédito, los importes antes desglosados incluyen Impuesto al valor agregado (IVA).</small> <br>
        <small><b>*</b> Para el tema fiscal debes considerar que sí tu esquema de facturación es enajenación de cartera, los importes antes desglosados no son gravados por (IVA).</small>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import { ClientTable } from 'vue-tables-2'

import mixins from '@/mixins'
import XLSX from 'xlsx'

Vue.use(ClientTable)

export default {
  name: 'InvestorPerformanceTable',
  props: {
    investorPerformance: {
      type: Array,
      required: true
    },
    month: {
      type: String
    },
    months: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      columns: [
        'month',
        'fr',
        'value'
      ],
      options: {
        headings: {
          month: 'mes',
          fr: 'id solicitud',
          value: 'monto'

        },
        texts: {
          count: 'Filas {to} de {count}',
          filter: '',
          filterPlaceholder: 'Buscar',
          first: 'Inicio',
          last: 'Fin',
          limit: 'Registros por página',
          noResults: 'No se encontraron registros'
        },
        sorteable: false,
        filterable: true,
        initialPage: 1,
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        pagination: {
          dropdown: false,
          chunk: 6,
          edge: true,
          nav: 'fixed'
        },
        resizableColumns: false
      },
      filterArray: []
    }
  },
  mixins: [mixins],
  methods: {
    filterList: function (array, month) {
      let newarr = array.filter((investorlist) => {
        if (month !== '0') {
          return investorlist.month === month
        }
        return array
      })
      this.filterArray = newarr
    },
    exportExcel: function () {
      let data = XLSX.utils.json_to_sheet(
        this.filterArray
      )
      data['A1'].v = 'mes'
      data['B1'].v = 'total_en_el_mes'
      data['C1'].v = 'id_solicitud'
      data['D1'].v = 'monto'
      const workbook = XLSX.utils.book_new()
      const filename = 'cumplo-rendimientos-devengados'

      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    }
  },
  watch: {
    investorPerformance: function () {
      this.filterList(this.investorPerformance, this.month)
    }
  },
  created: function () {
    this.filterList(this.investorPerformance, this.month)
  }

}
</script>

<style lang="scss">

  .margin-left-sm {
    margin-left: 1rem;
  }

  .table-performance {
    th, td{
        width: 300px;
    }
  }
  .table-investment {
    td,
    th {
      font-size: .9em;
      line-height: 1.2;
    }
    th b {
      color: #999;
    }
  }

.VueTables__search {
  margin-left: 1rem;
}

.VueTables__limit-field {
  margin-left: 2rem;
}

.VuePagination {
  text-align: center;

  > nav {
    width: 100%;

    > .VuePagination__pagination {
      display: block;

      > li {
        margin: 0 2px;

        a {
          padding: 4px 8px;
          background-color: $midnight-blue;
          color: $white;

          &.active {
            background-color: $yellow;
          }
        }

        &:before {
          display: none;
        }
      }
    }
  }

  li {
    display: inline-block;
  }
}

.table-virtualaccount {
  td,
  th {
    font-size: .9em;
    line-height: 1.2;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/InvestorPerformance/InvestorPerformanceTable.vue